import {Subject} from 'rxjs/Subject';
import {DEFAULT_SCROLLBAR, ScrollbarOptions} from './scrollbar-options';
/**
 * \@class ScrollbarConfig
 * 
 */
export class ScrollbarConfig {
/**
 * The scrollbars options.
 * A deep merge of the default options and the user provided options
 * 
 */
private options: ScrollbarOptions;
/**
 * @param {?} opt
 */
constructor(opt: ScrollbarOptions) {
    this.mergeOptions(opt, true);
  }
/**
 * Merge the defaults and options by performing a deep merge
 * 
 * 
 * @param {?} opt
 * @param {?=} setOpt
 * @param {?=} mergeWith
 * @return {?}
 */
mergeOptions(opt: ScrollbarOptions, setOpt: boolean = false, mergeWith?: ScrollbarOptions) {
    let /** @type {?} */ defaults = DEFAULT_SCROLLBAR;
    if (mergeWith) {
      defaults = mergeWith;
    }
    let /** @type {?} */ styles = {};
    let /** @type {?} */ classes = {};

    // Perform a deep merge of the styles objects if user passes any
    if (opt.styles) {
      const /** @type {?} */ keys = Object.keys(opt.styles);
      for (const /** @type {?} */ key of keys) {
        styles[key] = { ...defaults.styles[key], ...opt.styles[key] };
      }

      styles = { ...defaults.styles, ...styles};
    }else {
      styles = {...defaults.styles};
    }

    // Concatenate any user defined classes with the defaults
    if (opt.classes) {
      const /** @type {?} */ keys = Object.keys(opt.classes);
      for (const /** @type {?} */ key of keys) {
        classes[key] = [...defaults.classes[key], ...opt.classes[key]];
      }

      classes = { ...defaults.classes, ...classes};
    }else {
      classes = {...defaults.classes};
    }

    const /** @type {?} */ out = { ...defaults, ...opt, ...{styles}, ...{classes} };
    if (setOpt) {
      this.options = out;
    }

    return out;
  }
/**
 *
 * @return {?}
 */
get isRoot() {
    return this.options.isRoot;
  }
/**
 *
 * @return {?}
 */
get position() {
    return this.options.position;
  }
/**
 *
 * @return {?}
 */
get alwaysVisible() {
    return this.options.alwaysVisible;
  }
/**
 *
 * @return {?}
 */
get visibleTimeout() {
    return this.options.visibleTimeout;
  }
/**
 *
 * @return {?}
 */
get wrapperWidth() {
    return this.options.wrapperWidth;
  }
/**
 *
 * @return {?}
 */
get gridOffset() {
    return this.options.gridOffset;
  }
/**
 *
 * @return {?}
 */
get barOffset() {
    return this.options.barOffset;
  }
/**
 *
 * @return {?}
 */
get toggleClasses() {
    return this.options.toggleClasses;
  }
/**
 *
 * @return {?}
 */
get wStyles() {
    return this.options.styles.wrapper;
  }
/**
 *
 * @return {?}
 */
get gStyles() {
    return this.options.styles.grid;
  }
/**
 *
 * @return {?}
 */
get bStyles() {
    return this.options.styles.bar;
  }
/**
 *
 * @return {?}
 */
get wClass() {
    return this.options.classes.wrapper;
  }
/**
 *
 * @return {?}
 */
get gClass() {
    return this.options.classes.grid;
  }
/**
 *
 * @return {?}
 */
get bClass() {
    return this.options.classes.bar;
  }
}

function ScrollbarConfig_tsickle_Closure_declarations() {
/**
 * The scrollbars options.
 * A deep merge of the default options and the user provided options
 * 
 * @type {?}
 */
ScrollbarConfig.prototype.options;
}

